let lastScrollTop = 0;

export const headerScroll = () => {
  const header = document.getElementById("header");
  if (!header) return; // Sprawdzamy, czy header istnieje

  const st = window.scrollY || document.documentElement.scrollTop;

  if (st === 0) {
    header.classList.remove("isScrolled-up", "isScrolled-down", "isNearTop");
    document.querySelector("body").classList.remove("headerScrolled");
  } else if (st > lastScrollTop && st > 60) {
    header.classList.remove("isScrolled-up", "isNearTop");
    header.classList.add("isScrolled-down");
    document.querySelector("body").classList.add("headerScrolled");
  } else if (st < lastScrollTop) {
    if (st < 60 && st > 0) {
      header.classList.remove("isScrolled-down");
      header.classList.add("isNearTop");
    } else {
      header.classList.remove("isScrolled-down", "isNearTop");
      header.classList.add("isScrolled-up");
      document.querySelector("body").classList.add("headerScrolled");
    }
  }

  lastScrollTop = st <= 0 ? 0 : st;
};
